
import http  from '@/axios/http.js'

export default {
    doLogin(data) {
        return http.post('/login', data);
    }
};



// WEBPACK FOOTER //
// ./src/service/modules/login.js